export const CustomRate = () => ({
  carrier: '',
  carrierId: '',
  quoteId: '',
  level: '',
  transit_time: '',
  estimated_delivery: undefined,
  rate: '',
  notes: '',
  isCustomRate: true,
  isVolumeRate: false,
  canBeSelected: true
});

export default CustomRate;
